import ReactDOM from 'react-dom';
import { Helmet } from 'react-helmet';
import 'assets/fonts/fonts.css';
import App from './App';
import { chakraTheme } from 'cj-common-react';
import { ChakraProvider } from '@chakra-ui/react';

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <ChakraProvider theme={chakraTheme}>
    <Helmet>
      <meta property='og:title' content='CJ Home' />
      <meta property='og:description' content='CJ Home' />
      <meta property='og:image' content='/favicon.ico' />
    </Helmet>
    <App />
  </ChakraProvider>,
  document.getElementById('root')
);
